import { createGlobalStyle } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const DateRangeStyles = createGlobalStyle`
  div.rdrDefinedRangesWrapper {
    width: 170px;
    border: none;
    background-color: transparent;
  }

  div.rdrStaticRanges {
    > button {
      &:not(:last-child) {
        margin-bottom: 4px;
      }
    }
  }

  button.rdrDayToday {
        .rdrDayNumber {
              span:after {
                    background: ${themeGet('colors.primary.regular')};
              }
        }
  }

  button.rdrDay {
    font-size: 13px;
        height: 2.5em;
    color: ${themeGet('colors.primary.regular')};
  }

  button.rdrStaticRange {
    border: none;
    background-color: transparent;
    color: ${themeGet('colors.text.default')};
    
    span {
      border-radius: ${themeGet('radii.base')};
      transition: all .25s ease;
    }

    &:hover,
    &:focus {
      .rdrStaticRangeLabel {
        background-color: ${themeGet('colors.primary.light')};
      }
    }

  }

  div.rdrCalendarWrapper {
    display: flex;
    background-color: transparent;
        
    font-size: ${themeGet('fontSizes.sm')}px;
    color: ${themeGet('colors.primary.regular')};
  }

  div.rdrMonth {
    padding: 0;
    width: 100%;
  }

  div.rdrMonthName {
    text-align: center;
    text-transform: capitalize;
    color: ${themeGet('colors.primary.regular')};
  }

  span.rdrWeekDay {
    font-weight: 600;
    font-size: 13px;
    color: ${themeGet('colors.primary.regular')};
  }

  span.rdrStartEdge {
    border-top-left-radius: ${themeGet('radii.base')};
    border-bottom-left-radius: ${themeGet('radii.base')};
    background-color: ${themeGet('colors.primary.regular')};
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;    
  }

  span.rdrEndEdge {
    border-top-right-radius: ${themeGet('radii.base')};
    border-bottom-right-radius: ${themeGet('radii.base')};    
    background-color: ${themeGet('colors.primary.regular')};
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  button.rdrDayStartOfMonth span.rdrInRange,
  button.rdrDayStartOfMonth span.rdrEndEdge,
  button.rdrDayStartOfWeek span.rdrInRange,
  button.rdrDayStartOfWeek span.rdrEndEdge {
    border-top-left-radius: ${themeGet('radii.base')};
    border-bottom-left-radius: ${themeGet('radii.base')};
    left: 0; 
  }

  button.rdrDayStartOfMonth .rdrDayInPreview,
  button.rdrDayStartOfMonth .rdrDayEndPreview,
  button.rdrDayStartOfWeek .rdrDayInPreview,
  button.rdrDayStartOfWeek .rdrDayEndPreview {
      border-top-left-radius: ${themeGet('radii.base')};
      border-bottom-left-radius: ${themeGet('radii.base')};
  }

  button.rdrDayEndOfMonth .rdrDayInPreview,
  button.rdrDayEndOfMonth .rdrDayStartPreview,
  button.rdrDayEndOfWeek .rdrDayInPreview,
  button.rdrDayEndOfWeek .rdrDayStartPreview {
      border-top-right-radius: ${themeGet('radii.base')};
      border-bottom-right-radius: ${themeGet('radii.base')};
  }

  span.rdrSelected,
  span.rdrInRange,
  span.rdrStartEdge,
  span.rdrEndEdge {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
  }

  span.rdrInRange {
    background-color: #f6f6f6;
  }

  .rdrDayEndOfMonth .rdrInRange,
  .rdrDayEndOfMonth .rdrStartEdge,
  .rdrDayEndOfWeek .rdrInRange,
  .rdrDayEndOfWeek .rdrStartEdge {
    border-top-right-radius: ${themeGet('radii.base')};
    border-bottom-right-radius: ${themeGet('radii.base')};
  }

  button.rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span, 
  button.rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span, 
  button.rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,
  button.rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {
    font-weight: 600;
    color: ${themeGet('colors.primary.regular')};
  }

  button.rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
  button.rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span {
    color: ${themeGet('colors.body.bg')};;
  }

  span.rdrDayNumber {
    bottom: 0;
    top: 0;
    z-index: 5;    
    font-weight: ${themeGet('fontWeights.regular')};
    transition: all .25s ease;
        
    span {
      color: ${themeGet('colors.primary.regular')};
    }
  }

  button.rdrDayPassive,
  button.rdrDayDisabled {
    background-color: transparent;

    .rdrDayNumber {
       span {
          opacity: .4;
          color: ${themeGet('colors.primary.regular')};
       }
    }
  }

  button.rdrDayPassive span {
    color: transparent;
  }
  
  button.rdrDay {
     span.rdrStartEdge ~ span.rdrDayStartPreview,
     span.rdrStartEdge ~ span.rdrDayEndPreview,
     span.rdrEndEdge ~ span.rdrDayStartPreview,
     span.rdrEndEdge ~ span.rdrDayEndPreview {
        background: ${themeGet('colors.primary.regular')};
     }
  }

  span.rdrDayStartPreview,
  span.rdrDayInPreview,
  span.rdrDayEndPreview {
    top: 0;
    bottom: 0;
    border: none;
    background: #f6f6f6;
  }
  
  span.rdrDayHovered {
    span.rdrDayStartPreview,
    span.rdrDayInPreview,
    span.rdrDayEndPreview {
      background-color: ${themeGet('colors.primary.regular')};
    }
  }

  span.rdrDayStartPreview {
    border-top-left-radius: ${themeGet('radii.base')};
    border-bottom-left-radius: ${themeGet('radii.base')};
  }

  span.rdrDayEndPreview {
    border-top-right-radius: ${themeGet('radii.base')};
    border-bottom-right-radius: ${themeGet('radii.base')};
  }

  div.rdrMonthAndYearWrapper {
    padding-top: 0;
    height: auto;
    margin-bottom: 0;
  }
  
  button.rdrNextPrevButton {
    width: 40px;
    height: 40px;
    margin: 0;
    transition: all .25s ease;
    background-color: transparent;

    &:hover {
      background-color: #f6f6f6;
    }
  }

  span.rdrMonthAndYearPickers {

    select {
      transition: all .25s ease;
      color: ${themeGet('colors.text.default')};

      &:hover {
         background-color: ${themeGet('colors.primary.light')};
      }

    }

  }

  button.rdrPrevButton {
    i {
          margin: 0 auto;
      border-color: transparent ${themeGet(
        'colors.text.default'
      )} transparent transparent;
    }
  }

  button.rdrNextButton {
        
    i {
          margin: 0 auto;
      border-color: transparent transparent transparent ${themeGet(
        'colors.text.default'
      )};
    }
  }

`;
